import Vuex from 'vuex';
import Vue from 'vue';
import { Indicator, MessageBox } from 'mint-ui';


Vue.use(Vuex);

const store = new Vuex.Store({});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js